"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toQuery = exports.openPopup = exports.isMobileOrTablet = exports.encodedShareURL = exports.copyToClipboard = exports.addParamsToUrl = void 0;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable @typescript-eslint/no-explicit-any */
var toQuery = exports.toQuery = function toQuery(object) {
  var searchParams = Object.keys(object).map(function (k) {
    return object[k] ? encodeURIComponent(k) + '=' + encodeURIComponent(object[k]) : null;
  }).filter(function (e) {
    return e;
  }).join('&');
  return searchParams ? "?".concat(searchParams) : '';
};
var addParamsToUrl = exports.addParamsToUrl = function addParamsToUrl(oldUrl, params) {
  var newUrl = new URL(oldUrl);
  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    newUrl.searchParams.append(key, value);
  }
  return newUrl.href;
};
var encodedShareURL = exports.encodedShareURL = function encodedShareURL(url, utmParams) {
  return encodeURIComponent(url + toQuery(utmParams || {}));
};
var openPopup = exports.openPopup = function openPopup(url) {
  return window.open(url, 'sharer', 'toolbar=no,width=1042,height=436');
};
var copyToClipboard = exports.copyToClipboard = function copyToClipboard(value) {
  var tempEl = document.createElement('textarea');
  tempEl.value = value;
  document.body.appendChild(tempEl);
  tempEl.select();
  var success = document.execCommand('copy');
  document.body.removeChild(tempEl);
  if (!success) {
    var locale = document.documentElement.lang || 'de';
    var alertMessage = locale === 'de' ? 'Sorry, dein Browser unterstützt diese Funktion nicht.' : "Sorry, your Browser doesn't support this feature.";
    alert(alertMessage);
  }
  return success;
};
var isMobileOrTablet = exports.isMobileOrTablet = function isMobileOrTablet() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
};